// src/components/LandingPage.jsx
import React from "react";
import { Link } from "react-router-dom";

const LandingPage = () => (
  <div className="landing-page">
    <section className="hero">
      <h1>Raise Funds with Fractional NFTs</h1>
      <p>Revolutionize fundraising by tokenizing your assets.</p>
      <div className="cta-buttons">
        <Link to="/asset-selection">
        <button onClick={() => console.log("Start Fractionalizing")}>Start Fractionalizing</button>
        </Link>
        <Link to="">
        <button onClick={() => console.log("Learn More")}>Learn More</button>
        </Link>

      </div>
    </section>
  </div>
);

export default LandingPage;
